<template>
  <SharePageTemplate>
    <template v-slot:image-content>
      <ImageCompareSlider
        :sliderLineWidth="2"
        :leftImage="$route.query.start"
        :rightImage="$route.query.end"
        :switch="false"
      />
    </template>
  </SharePageTemplate>
</template>

<script>
import ImageCompareSlider from '@components/image/ImageCompareSlider.vue';
import SharePageTemplate from '@/components/share/SharePageTemplate.vue';

export default {
  name: 'SharedSliderCompareView',
  components: {ImageCompareSlider, SharePageTemplate},
};
</script>
